export function TrialTag({
  sessionNumber,
}: Readonly<{ sessionNumber?: number }>) {
  return (
    <div className="absolute top-[-4px] right-2 md:top-[-7px] md:right-2 z-[1]">
      <div className="relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="160"
          height="42.873"
          viewBox="0 0 160 42.873"
          fill="none"
          className="w-32 h-6 md:w-42 md:h-8"
        >
          <path
            d="M20.216 9.576H0A9.576 9.576 0 0 1 9.576 0H142.285c9.403 0 17.024 7.622 17.024 17.024V33.516a8.509 8.509 0 0 1 -8.513 8.513H28.729a8.513 8.513 0 0 1 -8.513 -8.513z"
            fill="#FAB82B"
          />
          <path
            d="M5.319 9.576a4.255 4.255 0 0 1 4.256 -4.256h6.384a4.255 4.255 0 0 1 4.257 4.256z"
            fill="#C8921F"
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center gap-1 text-white text-[8px] md:text-xs font-light ml-2.5 px-you 5 md:px-5">
          {sessionNumber ? (
            <span className="flex items-center justify-center w-3.5 h-3.5 md:w-4 md:h-4 rounded-full border border-white text-[8px] md:text-[8px]">
              {sessionNumber}
            </span>
          ) : null}
          Trial Session
        </span>
      </div>
    </div>
  );
}
